export function isExternalFileUrl(url?: string): boolean {
    if (!url) return false;
    try {
        const parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
}

export function openFileInNewTab(url?: string): boolean {
    if (!isExternalFileUrl(url)) return false;
    window.open(url!, '_blank', 'noopener,noreferrer');
    return true;
}

// Origins from which file/report resources are allowed to be trusted for
// iframe embedding (bypassSecurityTrustResourceUrl). Restricts trust to our
// own S3/CloudFront/app domains so a bad or attacker-controlled URL returned
// by the API cannot be loaded as arbitrary external content.
export const TRUSTED_FILE_DOMAINS = [
    // Intentionally broad — S3/presigned URLs (regional & legacy endpoints). The APT
    // API is the real trust boundary: only URLs it returns ever reach this check.
    '.amazonaws.com',
    '.cloudfront.net', // CDN (e.g. d8a010h0zbs64.cloudfront.net)
    '.appliedparticle.io', // app + API domains
];

export function isTrustedFileUrl(url?: string): boolean {
    if (!isExternalFileUrl(url)) return false;
    try {
        const { hostname } = new URL(url!);
        // Suffix match only: each entry starts with a dot, so a bare domain
        // (e.g. "amazonaws.com") is never trusted — only genuine subdomains are.
        return TRUSTED_FILE_DOMAINS.some((d) => hostname.endsWith(d));
    } catch {
        return false;
    }
}
